/** Scale (<= 1) that makes content of `natural` height fit in `available` (never enlarges, never below `min`) */
export function fitScale(natural: number, available: number, min = 0.6): number {
  if (natural <= 0 || available <= 0 || natural <= available) return 1;
  return Math.max(min, available / natural);
}
